<template>
  <div class="tab_simcards">
    <div class="response_table" v-if="simcard_list.length > 0">
      <div class="header_simcards">
        <h4 class="title">{{ title }}</h4>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col">
              mno_name
            </th>
            <th scope="col">
              msisdn
            </th>
            <th scope="col">
              imsi
            </th>
            <th scope="col">
              iccid
            </th>
            <th scope="col">
              status
            </th>
            <th scope="col">
              ts_status_update
            </th>
          </tr>
        </thead>
        <tbody>
        <router-link
          :to="go_to(sim.id)"
          v-for="(sim,key) in simcard_list"
          :key="key"
        >

          <tr class="link pointer">
            <td data-label="mno_name">{{ sim.mno_name }}</td>
            <td data-label="msisdn">{{ sim.msisdn }}</td>
            <td data-label="imsi">{{ sim.imsi }}</td>
            <td data-label="iccid">{{ sim.iccid }}</td>
            <td data-label="status">
              <span class="badge" :class="simcard_status_color(+sim.status)">
                {{simcard_status_text(+sim.status)}}
              </span>
            </td>
            <td data-label="ts_status_update">{{ get_date(sim.ts_status_update) }}</td>
          </tr>

        </router-link>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'simcard_list',
  props: ['title', 'simcard_list'],
  computed:{
    sims_list(){
      let list = this.simcard_list

      if (this.sims_sort === 'asc') {
        list.sort((a, b) => a.ts_sync < b.ts_sync ? 1 : -1)
      }else{
        list.sort((a, b) => a.ts_sync > b.ts_sync ? 1 : -1)
      }

      return list
    }
  },
  methods: {
    go_to (id) {
      return {path: '/simcard_profile/' + id}
    },
    get_simcard_status (sim) {
      return sim.status ? 1 : 0
    },
    simcard_status_text(status){
      switch (status) {
        case -1: return this.translate('simcard_profile.status_info.undefined')
        case 1: return this.translate('simcard_profile.status_info.active')
        case 2: return this.translate('simcard_profile.status_info.blocked')
        case 3: return this.translate('simcard_profile.status_info.prepare')
        case 4: return this.translate('simcard_profile.status_info.stop')
      }
    },
    simcard_status_color(status){
      switch (status) {
        case -1: return 'gray'
        case 1: return 'green'
        case 2: return 'yellow'
        case 3: return 'blue'
        case 4: return 'red'
      }
    },
  },
}
</script>
<style lang='scss' scoped>
  .tabs-component-panel .tab_simcards{
    .header_simcards{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .title{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
      }
      .switch{
        font-size: 12px;
        line-height: 120%;
      }
    }
    .response_table{
      padding: 0;
      table tr {
        background-color: white;
        .link{
          .icon{
            font-size: 18px;
          }
        }
      }
      &:first-child{
        margin-bottom: 10px;
      }
      h4.block_title{
        margin: 0 0 15px;
      }
    }
  }
  .pointer{
    cursor: pointer;
  }
 </style>
